import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { LettingsPropertyLite } from '@src/app/models/lettingsPropertyLite';
import { Observable } from 'rxjs';
import { PropertyCertificateType } from '@core/enums/PropertyCertificateType';
import { DiarySummary } from '@src/app/models/diarySummary';
import { HMOSubProperty } from '@src/app/models/hMOSubProperty';
import { LettingsProperty } from '@src/app/models/lettingsProperty';
import { LettingsPropertyHMODetails } from '@src/app/models/lettingsPropertyHMODetails';
import { PropertyCertificate } from '@src/app/models/propertyCertificate';
import { PropertyCertificateDue } from '@src/app/models/propertyCertificateDue';
import { PropertyCertificateEPCDue } from '@src/app/models/propertyCertificateEPCDue';
import { PropertyIdWithAddress } from '@src/app/models/propertyIdWithAddress';
import { ApplicantCriteriaForPropertyMatches } from '@src/app/models/applicantCriteriaForPropertyMatches';
import { lettingsPropertyDetails } from '../../models/lettingsPropertyDetails';
import { PropertySimple } from '@src/app/models/propertySimple';
import { PropertyStub } from '@src/app/models/propertyStub';
import { UserProfile } from '@src/app/models/userProfile';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private _baseService: BaseApiService) {  }

  getMyProfile(): Observable<UserProfile> {
    const url = `/api/userprofile/me`;
    return this._baseService.get<UserProfile>(url);
  }

  // get(id: number): Observable<UserProfile> {
  //   const url = `/api/userprofile/${id}`;
  //   return this._baseService.get<UserProfile>(url);
  // }

  upsert(userProfile: UserProfile): Observable<number> {
    const url = `/api/userprofile`;
    return this._baseService.post<number>(url, userProfile);
  }

}
